if(BSS_BCP_V2?.r4q?.logics?.length){
    if(Shopify.locale === "nl") {
        BSS_BCP_V2.r4q.translation = {
            quote_button_content: "Toevoegen aan offerte",
            total_quantity: "Totale hoeveelheid",
            modal_header_title: "Offerte aanvragen",
            product_section_heading: "Geoffreerde producten",
            product_table_product_variant: "Variant: ",
            product_table_product_sku: "SKU: ",
            product_table_product_barcode: "Barcode: ",
            product_table_product_type: "Type: ",
            product_table_product_vendor: "Leverancier: ",
            product_table_product_available_quantity: "Beschikbare hoeveelheid: ",
            product_table_product_offer_button: "Aanbiedingsprijs",
            product_table_product_offer_price: "Aanbiedingsprijs: ",
            product_table_product_offer_placeholder: "Uw prijs",
            product_table_product_note_placeholder: "Voeg aanvullende vereisten toe voor dit product",
            product_empty_heading: "Geen items in uw offerteaanvraaglijst",
            product_empty_message: "Zoek en voeg producten toe om een offerte aan te vragen",
            add_items_success_heading: "Items toegevoegd aan offerteaanvraaglijst",
            add_items_success_message: "U heeft de items succesvol toegevoegd aan uw offerteaanvraaglijst.",
            add_items_failure_heading: "Items toevoegen mislukt",
            add_items_failure_message: "Er is een probleem opgetreden bij het toevoegen van de items aan uw offerteaanvraaglijst. Probeer het opnieuw.",
            toast_view_quote_button: "Offerteaanvraaglijst bekijken",
            eligible_notice_title: "Kennisgeving offerteaanvraag geschiktheid",
            eligible_all_items_invalid:
                "Helaas komt geen van de items in aanmerking voor een offerteaanvraag. Voeg producten toe die in aanmerking komen om verder te gaan.",
            eligible_exist_invalid_items: "Bepaalde items komen niet in aanmerking voor een offerte:",
            eligible_continue_or_return: "U kunt doorgaan met de in aanmerking komende items of teruggaan om aan te passen.",
            eligible_return_button: "Terug",
            eligible_continue_button: "Doorgaan",
            form_section_heading: "Informatie invullen",
            modal_footer_cancel_button: "Verder winkelen",
            modal_footer_submit_button: "Aanvraag indienen",
            state_file_uploading: "Bestand uploaden",
            file_choose_button: "Bestand kiezen",
            file_replace_button: "Bestand vervangen",
            after_submit_heading: "Offerteaanvraag succesvol verzonden",
            after_submit_message: "Uw offerteaanvraag is ontvangen. Ons team beoordeelt deze en neemt spoedig contact met u op",
            after_submit_quote_id: "Offerte-ID: #",
            after_submit_back_button: "Terug naar winkel",
            error_required: "{{label}} is verplicht",
            error_invalid: "{{label}} is ongeldig",
            error_file_type:
                "Bestandstype moet een van de volgende zijn: .csv, .doc, .docx, .gif, .jpg, .jpeg, .png, .pdf, .wav, .xls, .xlsx, .zip, .mp4, .txt",
            error_file_size: "Bestandsgrootte mag niet groter zijn dan {{maxSize}}MB",
            error_video_size: "Videogrootte mag niet groter zijn dan {{maxSize}}MB",
            error_video_width: "Videobreedte moet tussen {{minWidth}}px en {{maxWidth}}px liggen",
            error_video_height: "Videohoogte moet tussen {{minHeight}}px en {{maxHeight}}px liggen",
            error_video_resolution: "Videoresolutie mag niet hoger zijn dan {{maxResolution}}MP",
            error_video_duration: "Videoduur moet tussen {{minDuration}} seconden en {{maxDuration}} seconden liggen",
            error_image_size: "Afbeeldingsgrootte mag niet groter zijn dan {{maxSize}}MB",
            error_image_aspect_ratio: "Beeldverhouding moet tussen {{minAspectRatio}} en {{maxAspectRatio}} liggen",
            error_image_resolution: "Afbeeldingsresolutie mag niet hoger zijn dan {{maxResolution}}MP",
            error_min_value: "{{label}} moet groter dan of gelijk zijn aan {{min}}",
            error_max_value: "{{label}} moet kleiner dan of gelijk zijn aan {{max}}",
            error_min_length: "{{label}} heeft het minimumaantal tekens van {{minLength}} niet bereikt",
            error_max_length: "{{label}} heeft het maximumaantal tekens van {{maxLength}} overschreden",
            history_created_at: "Aanmaakdatum",
            history_restricted_heading: "Deze pagina is alleen voor ingelogde klanten",
            history_restricted_description: "Log in op uw account om toegang te krijgen tot deze pagina",
            history_restricted_primary_button: "Inloggen",
            history_restricted_secondary_button: "Terug",
            history_page_title: "Mijn offertegeschiedenis",
            history_page_subtitle: "Volg uw aangemaakte offertes en krijg toegang tot uitgebreide details voor elke aanvraag.",
            history_search_quote: "Offerte zoeken",
            history_filter_status: "Status",
            history_filter_all: "Alle",
            history_sort_by: "Sorteren op",
            history_sort_newest: "Nieuwste",
            history_sort_oldest: "Oudste",
            history_empty_heading: "Geen offertes beschikbaar",
            history_empty_description: "Uw offertelijst is leeg of geen offertes komen overeen met uw zoekopdracht en filters",
            history_quote_name: "Offerte #",
            history_table_customer: "Klant",
            history_table_company: "Bedrijf",
            history_table_location: "Locatie",
            quote_status_unread: "Ongelezen",
            quote_status_review: "In beoordeling",
            quote_status_converted: "Geconverteerd",
            quote_status_rejected: "Afgewezen",
            quote_proposal_sent: "Voorstel verzonden",
            detail_page_title: "Offertedetail #",
            detail_table_product: "PRODUCT",
            detail_table_quoted_price: "GEOFFREERDE PRIJS",
            detail_table_quantity: "HOEVEELHEID",
            detail_table_total: "TOTAAL",
            detail_table_sku: "SKU",
            detail_table_barcode: "Barcode",
            detail_table_vendor: "Leverancier",
            detail_table_note: "Opmerking",
            detail_payment_heading: "BETALINGSINFORMATIE",
            detail_payment_subtotal: "Subtotaal",
            detail_payment_items: "item(s)",
            detail_payment_shipping: "Verzending",
            detail_payment_tax: "Belasting",
            detail_payment_total: "Eindbedrag",
            detail_payment_tax_exempt: "Belastingvrij",
            detail_payment_taxes_included: "Inbegrepen",
            detail_checkout_button: "AFREKENEN",
            detail_payment_terms: "BETALINGSVOORWAARDEN",
            detail_customer_heading: "KLANTINFORMATIE",
            detail_shipping_heading: "VERZENDINFORMATIE",
            detail_additional_heading: "AANVULLENDE INFORMATIE",
            detail_no_notes: "Geen opmerkingen",
            detail_deleted_product: "Verwijderd product",
            detail_awaiting_merchant: "In afwachting van handelaar",
            create_similar_quote: "Vergelijkbare offerte maken",
            fallback_error_heading: "Er is iets misgegaan",
            fallback_error_message: "Er is een fout opgetreden bij het verwerken van uw aanvraag. Probeer het opnieuw of neem contact op met de handelaar",
            link_error_heading: "Linkfout",
            link_error_message: "Deze link is verlopen. Neem contact op met de handelaar om een nieuw voorstel te ontvangen.",
            approved_error_heading: "Offerte reeds goedgekeurd",
            approved_error_message: "Deze offerte is al goedgekeurd. U kunt de huidige status bekijken in uw offertegeschiedenis.",
            rejected_error_heading: "Offerte reeds afgewezen",
            rejected_error_message: "Deze offerte is al afgewezen. U kunt de bijgewerkte informatie bekijken in uw offertegeschiedenis.",
            approve_success_heading: "Offerte succesvol goedgekeurd",
            approve_success_message: "De offerte is succesvol goedgekeurd. Controleer uw mailbox om uw factuur te bekijken.",
            reject_success_heading: "Offerte succesvol afgewezen",
            reject_success_message: "De offerte is succesvol afgewezen. U kunt de bijgewerkte informatie bekijken in de offertedetails.",
            reject_modal_title: "Afwijzing bevestigen",
            reject_modal_message: "Weet u zeker dat u deze offerte wilt afwijzen? U kunt optioneel hieronder een reden opgeven.",
            reject_cancel_button: "Annuleren",
            reject_confirm_button: "Bevestigen",
            po_number: "Inkoopordernummer"
        }
        BSS_BCP_V2.r4q.logics[0].formFields[0].label = "Algemene informatie";
        BSS_BCP_V2.r4q.logics[0].formFields[1].label = "Voornaam";
        BSS_BCP_V2.r4q.logics[0].formFields[2].label = "Achternaam";
        BSS_BCP_V2.r4q.logics[0].formFields[3].label = "E-mail";
        BSS_BCP_V2.r4q.logics[0].formFields[4].label = "Verzendadres";

        BSS_BCP_V2.r4q.logics[0].formFields[4].fields[0].label = "Verzendadres";
        BSS_BCP_V2.r4q.logics[0].formFields[4].fields[1].fields[0].label = "Land/Regio";
        BSS_BCP_V2.r4q.logics[0].formFields[4].fields[1].fields[1].label = "Provincie/Staat";
        BSS_BCP_V2.r4q.logics[0].formFields[4].fields[2].label = "Voornaam";
        BSS_BCP_V2.r4q.logics[0].formFields[4].fields[3].label = "Achternaam";
        BSS_BCP_V2.r4q.logics[0].formFields[4].fields[4].label = "Bedrijf";
        BSS_BCP_V2.r4q.logics[0].formFields[4].fields[5].label = "Adres";
        BSS_BCP_V2.r4q.logics[0].formFields[4].fields[6].label = "Appartement";
        BSS_BCP_V2.r4q.logics[0].formFields[4].fields[7].label = "Stad";
        BSS_BCP_V2.r4q.logics[0].formFields[4].fields[8].label = "Postcode";
        BSS_BCP_V2.r4q.logics[0].formFields[4].fields[9].label = "Telefoon";
        BSS_BCP_V2.r4q.logics[0].formFields[4].fields[9].fields[0].label = "Land/Regio";
        BSS_BCP_V2.r4q.logics[0].formFields[4].fields[9].fields[1].label = "Telefoon";
    }
}